import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBpFh5i0E_pkpC6icuSkPLAs2jV8kDV-IU",
  authDomain: "bolsa-empleo-instituto.firebaseapp.com",
  databaseURL: "https://bolsa-empleo-instituto.firebaseio.com",
  projectId: "bolsa-empleo-instituto",
  storageBucket: "bolsa-empleo-instituto.appspot.com",
  messagingSenderId: "612015217906",
  appId: "1:612015217906:web:6c116d15baa33765a1446b",
  measurementId: "G-55TDHKZ6XE"
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();

